import { Module } from 'vuex';
import HotelService from '@/services/landing/hotel.service';
import { GetRoomTypesInterface } from '@/types/api/landing/roomTypesInterface';
import { RoomDataInterface } from '@/types/store/landing/hotels/roomDataInterface';
import { HotelDataInterface } from '@/types/store/landing/hotels/hotelDataInterface';
import { HotelsStoreInterface } from '@/types/store/landing/hotels/hotelsStoreInterface';

const getDefaultState = (): HotelsStoreInterface => {
  return {
    item: {
      address: {
        en: '',
        ja: '',
      },
      cancellation_policy: {
        default_rate: 0,
        higher_rate: 0,
        days_before_start: 0,
        days: 0,
      },
      checkin_from: '',
      checkin_until: '',
      checkout_until: '',
      hotel_hid: '',
      in_campaign: false,
      latitude: 0,
      logo_url: '',
      longitude: 0,
      max_room_types_capacity: 0,
      name: {
        en: '',
        ja: '',
      },
      phone: '',
      prefecture_code: 0,
      privacy_policy: {
        en: '',
        ja: '',
      },
      site: '',
      updated_at: '',
      zip_code: '',
    },
    room: {
      amenities: [],
      description: {
        en: '',
        ja: '',
      },
      hid: '',
      images: [],
      name: {
        en: '',
        ja: '',
      },
      non_smoking: false,
      rate_plans: [],
    },
  };
};

const hotelStore: Module<HotelsStoreInterface, any> = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setHotel(state, hotel: HotelDataInterface) {
      state.item = { ...hotel };
    },
    setRoomInfo(state, room: RoomDataInterface) {
      state.room = { ...room };
    },
  },
  actions: {
    getRoomTypeInfo(context, data: GetRoomTypesInterface) {
      return HotelService.getRoomTypeInfo(data);
    },
    getLegalInfo(context, hid: string) {
      return HotelService.getLegalInfo(hid);
    },
    resetState({ commit }, data) {
      if (data) {
        commit('setHotel', data.current_hotel);
        commit('setRoomInfo', getDefaultState().room);
      }
    },
  },
};

export default hotelStore;
